import Vue from 'vue';
import VueRouter from 'vue-router';
import App from './App.vue';
import Home from './components/Home.vue';
import Project from './components/Project.vue';

Vue.use(VueRouter);
const router = new VueRouter({
  mode: 'history',
  routes: [{
    path: '/',
    component: Home,
    name: 'home'
  },
  {
    path: '/project/:title',
    component: Project,
    name: 'project'
  },
  {
    path: '*',
    redirect: '/'
  }]
});

Vue.directive('scroll', {
  inserted: function (el, binding) {
    let f = function (evt) {
      if (binding.value(evt, el)) {
        window.removeEventListener('scroll', f)
      }
    }
    window.addEventListener('scroll', f)
  }
});

new Vue({
  el: '#app',
  router: router,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js